import { Add, Check, Description } from '@mui/icons-material'
import { Button, Typography } from '@mui/material'
import { Box } from '@mui/system'
import React, { useState } from 'react'

export enum FileUploadIcon {
  PLUS = 'Plus', // eslint-disable-line no-unused-vars
  DECK = 'Deck', // eslint-disable-line no-unused-vars
}

interface Props {
  fileSelected: (file: any) => void
  icon: FileUploadIcon
  diameter: number
  title: string
  subtitle: string,
  style?: React.CSSProperties
  accepts: string
}

const FileUploadElement = (props: Props) => {
  const [fileName, setFileName] = useState<string | undefined>(undefined)

  const fileSelected = (e: any) => {
    e.preventDefault()
    const files = Array.from(e.target.files ?? [])
    if (files.length) {
      const file = files[0] as any
      setFileName(file.name)
      props.fileSelected(file)
    }
  }

  return (
    <Button onDrop={fileSelected} variant='outlined' component='label' style={props.style ?? {}}>
      <Box 
        display='flex' 
        flexDirection='column' 
        alignItems='center' 
        justifyContent='space-between'
      >
        {fileName !== undefined &&
          <>
            <Check sx={{
              width: `${props.diameter}px`,
              height: `${props.diameter}px`
            }} />
            <Typography variant='body1' m={'6px'}>{fileName}</Typography>
            <Typography variant='caption' m={'6px'}>File selected</Typography>
          </>
        }
        {fileName === undefined &&
          <>
            {props.icon === FileUploadIcon.DECK &&
              <Description sx={{
                width: `${props.diameter}px`,
                height: `${props.diameter}px`
              }} />
            }
            {props.icon === FileUploadIcon.PLUS &&
              <Add sx={{
                width: `${props.diameter}px`,
                height: `${props.diameter}px`
              }} />
            }
            <Typography variant='body1' m={'6px'}>{props.title}</Typography>
            <Typography variant='caption' m={'6px'}>{props.subtitle}</Typography>
          </>
        }
      </Box>
      <input type='file' accept={props.accepts} onChange={fileSelected} hidden />
    </Button>
  )
}

export default FileUploadElement
